import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";




export const authState = {
    //    updateState: false,
    //    loading: false,
    user: localStorage.getItem('adminToken') ? jwtDecode(localStorage.getItem('adminToken')) : '',
    token: localStorage.getItem('adminToken') ? localStorage.getItem('adminToken') : null,
    accessData: localStorage.getItem('accessData') ? localStorage.getItem('accessData') : null,
    // menu: localStorage.getItem('menu') ? localStorage.getItem('menu') : null,
    // permissions: localStorage.getItem('permissions') ? localStorage.getItem('permissions') : null,
};
const authSlice = createSlice({
    name: 'auth',
    initialState: authState,
    reducers: {
        setCredentials:  (state, action) => {
            const {token,accessData} = action.payload.data;
            // console.log(token,'TOKENNNNNNNN');
            localStorage.setItem('adminToken', token);
            localStorage.setItem('accessData', JSON.stringify(accessData[0]));
            // localStorage.setItem('menu', accessData[0].menu);
            // localStorage.setItem('permissions', accessData[0].permissions);
            // console.log('Response',jwtDecode(token),'Access Token',token);
            state.user = jwtDecode(token);
            state.token = token;
            state.accessData =  JSON.stringify(accessData[0]);
        },
        logOut: (state, action) => {
            state.user = null;
            state.token = null;
            state.accessData = null;
            // localStorage.removeItem('permissions');
            // localStorage.removeItem('menu');
            localStorage.removeItem('accessData');
            localStorage.removeItem('adminToken');
        }
    },
})

export const {setCredentials, logOut} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
// export const selectMenu = (state) => state.auth.menu;
// export const selectPermissions = (state) => state.auth.permissions;
export const selectCurrentToken = (state) => state.auth.token;
export const selectAccessData = (state) => state.auth.accessData;